<template>
    <td
        v-if="visible"
        :class="rootClasses"
        :style="{left: stuckLeftPosition ? `${stuckLeftPosition}px` : null}"
        :data-label="label">
        <slot/>
    </td>
</template>

<script>
import { BTableColumn } from 'buefy/src/components/table';

export default {
  name: 'ModernTableColumn',
  extends: BTableColumn,
  props: ['stuckLeftPosition'],
};
</script>
